document.addEventListener('DOMContentLoaded', function() {
  // Initialize all Manual Reviews Carousels on the page
  const carousels = document.querySelectorAll('.manual-reviews-splide');

  carousels.forEach(function(carousel) {
    initializeReviewsCarousel(carousel);
  });

  // Reinitialize carousels when sections are reloaded in theme editor
  document.addEventListener('shopify:section:load', function(event) {
    const carouselsInSection = event.target.querySelectorAll('.manual-reviews-splide');
    carouselsInSection.forEach(function(carousel) {
      initializeReviewsCarousel(carousel);
    });
  });
});

function initializeReviewsCarousel(carouselElement) {
  // Get section settings from the element's section
  const section = carouselElement.closest('.manual-reviews-carousel');
  if (!section) return;

  // Clean up any existing Splide instance
  if (carouselElement.splideInstance) {
    carouselElement.splideInstance.destroy();
    carouselElement.splideInstance = null;
  }

  // Clear any existing pagination to prevent duplication
  const existingPagination = carouselElement.querySelector('.splide__pagination');
  if (existingPagination) {
    existingPagination.innerHTML = '';
  }

  // Extract settings from data attributes (these would be set via Liquid)
  const sectionId = carouselElement.id.replace('manual-reviews-', '');
  const settingsScript = document.querySelector(`#reviews-settings-${sectionId}`);

  // Default settings
  let settings = {
    reviewsPerPage: 2,
    reviewsPerPageMobile: 1,
    showPagination: true,
    autoplay: false,
    autoplaySpeed: 5000
  };

  // Override with section settings if available
  if (settingsScript) {
    try {
      const sectionSettings = JSON.parse(settingsScript.textContent);
      settings = { ...settings, ...sectionSettings };
    } catch (e) {
      console.warn('Failed to parse reviews carousel settings:', e);
    }
  }

  // Determine responsive breakpoints
  const isMobile = window.innerWidth <= 767;
  const perPage = isMobile ? settings.reviewsPerPageMobile : settings.reviewsPerPage;

  // Splide configuration for reviews carousel
  const splideConfig = {
    type: 'loop',
    perPage: perPage,
    perMove: 1,
    gap: '1.5rem',
    padding: '5rem',
    breakpoints: {
      767: {
        perPage: settings.reviewsPerPageMobile,
        gap: '1rem',
        padding: '2rem'
      },
      1024: {
        perPage: Math.min(settings.reviewsPerPage, 3),
        gap: '1.25rem'
      }
    },
    arrows: false,
    pagination: settings.showPagination,
    autoplay: settings.autoplay,
    interval: settings.autoplaySpeed,
    pauseOnHover: true,
    pauseOnFocus: true,
    resetProgress: false,
    rewind: true,
    focus: 0,
    trimSpace: false,
    updateOnMove: true,
    classes: {
      pagination: 'splide__pagination',
      page: 'splide__pagination__page'
    }
  };

  // Initialize Splide
  try {
    const splide = new Splide(carouselElement, splideConfig);

    // Mount the carousel
    splide.mount();

    // Handle responsive changes
    let resizeTimeout;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(function() {
        const newIsMobile = window.innerWidth <= 767;
        const newPerPage = newIsMobile ? settings.reviewsPerPageMobile : settings.reviewsPerPage;

        // Update configuration if screen size category changed
        if (newIsMobile !== isMobile) {
          splide.options = {
            perPage: newPerPage
          };
          splide.refresh();
        }
      }, 250);
    });

    // Store the splide instance for potential cleanup
    carouselElement.splideInstance = splide;

    // Add accessibility improvements
    enhanceAccessibility(carouselElement, splide);

  } catch (error) {
    console.error('Failed to initialize Manual Reviews Carousel:', error);

    // Fallback: show all slides in a grid if Splide fails
    const track = carouselElement.querySelector('.splide__track');
    const list = carouselElement.querySelector('.splide__list');

    if (track && list) {
      track.style.overflow = 'visible';
      list.style.display = 'grid';
      list.style.gridTemplateColumns = `repeat(auto-fit, minmax(280px, 1fr))`;
      list.style.gap = '1.5rem';
      list.style.transform = 'none';

      // Hide navigation elements
      const pagination = carouselElement.querySelector('.splide__pagination');
      if (pagination) pagination.style.display = 'none';
    }
  }
}

// Enhance accessibility for the carousel
function enhanceAccessibility(carouselElement, splide) {
  // Add ARIA labels
  carouselElement.setAttribute('role', 'region');
  carouselElement.setAttribute('aria-label', 'Customer reviews carousel');

  // Add proper labels to slides
  const slides = carouselElement.querySelectorAll('.splide__slide');
  slides.forEach((slide, index) => {
    slide.setAttribute('role', 'group');
    slide.setAttribute('aria-label', `Review ${index + 1} of ${slides.length}`);
  });

  // Add keyboard navigation
  splide.on('mounted move', function() {
    const currentSlide = carouselElement.querySelector('.splide__slide.is-active');
    if (currentSlide) {
      currentSlide.setAttribute('aria-current', 'true');
    }
  });

  // Handle keyboard navigation
  carouselElement.addEventListener('keydown', function(e) {
    if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
      e.preventDefault();
      if (e.key === 'ArrowLeft') {
        splide.go('-1');
      } else {
        splide.go('+1');
      }
    }
  });
}

// Cleanup function for theme editor
document.addEventListener('shopify:section:unload', function(event) {
  const carouselsInSection = event.target.querySelectorAll('.manual-reviews-splide');
  carouselsInSection.forEach(function(carousel) {
    if (carousel.splideInstance) {
      carousel.splideInstance.destroy();
      carousel.splideInstance = null;
    }

    // Clean up any remaining pagination elements
    const pagination = carousel.querySelector('.splide__pagination');
    if (pagination) {
      pagination.innerHTML = '';
    }
  });
});

// Initialize reviews when page is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeAllReviewsCarousels);
} else {
  initializeAllReviewsCarousels();
}

function initializeAllReviewsCarousels() {
  const carousels = document.querySelectorAll('.manual-reviews-splide');
  carousels.forEach(initializeReviewsCarousel);
}